import React from "react";

const LoaderMain = ({
  size = "md",
  className = "",
  bgClassName = "bg-black/20",
}) => {
  const sizeClasses = {
    sm: "w-8 h-8 border-2",
    md: "w-12 h-12 border-4",
    lg: "w-16 h-16 border-4",
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${bgClassName} ${className}`}
    >
      <div
        className={`${sizeClasses[size]} border-t-transparent rounded-full animate-spin border-blue-600`}
        role="status"
        aria-label="Loading"
      />
    </div>
  );
};

export default LoaderMain;